export default function groupBy<T = any>(items: T[], key: string) {
  return items.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) });
  }, {} as T);
}
